import React from 'react';

import routes from 'config/routes';

import Routes from 'app-shell/Routes/Routes';

import './Content.scss';

export class Content extends React.Component {
  public render() {
    return (
      <div className="a-content-container">
        <Routes items={routes} />
      </div>
    );
  }
}

export default Content;
